import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useSessions(limit = 50) {
  return useQuery({
    queryKey: ['sessions', limit],
    queryFn: () => api.listSessions(limit),
    refetchInterval: 15_000,
  });
}
